import styled from 'styled-components';
import { BodyText, theme } from 'modules/ui';
import { mediaQuery } from 'modules/utils';

export const StyledSuccessActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  margin: 5rem 0;
`;

export const StyledSuccessIconContainer = styled.div<{
  success: boolean;
  successIconColor: string;
  failIconColor: string;
}>`
  width: 6.25rem;
  height: 6.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
  svg {
    height: 100%;
    width: 100%;

    g,
    path {
      fill: ${(props) =>
        props.success ? `${props.successIconColor}` : `${props.failIconColor}`};
    }
  }
`;

export const StyledSuccessTitle = styled.span`
  font-size: var(--h2-font-size);
  font-weight: ${theme.fontWeight.bold};
  line-height: var(--h2-line-height);
  margin-bottom: 0.6rem;
`;

export const StyledSuccessDescription = styled(BodyText)`
  margin-bottom: 0.6rem;
`;

export const StyledSuccessButtonContainer = styled.div`
  margin-top: 5em;
  width: 100%;

  button {
    width: 100%;
  }

  ${mediaQuery('md')} {
    margin-top: 2.15rem;

    button {
      width: auto;
      padding-left: 3.125rem;
      padding-right: 3.125rem;
    }
  }
`;
